import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { CtaBand } from '../components/ui/CtaBand';
import { FaqList } from '../components/ui/FaqList';
import { SectionHeading } from '../components/ui/SectionHeading';
import { faqs, steps } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function HowItWorks() {
  useDocumentMeta({
    title: 'How care works — Republic',
    description: 'Intake, labs, a written protocol you approve, then ongoing adjustment against real data. A clinic that shows its work.'
  });
  return <main data-id="element-371" data-mp="1ok8e93wlm4fv">
      <PageHeader eyebrow="How it works" title="A clinic that shows its work." intro="Republic runs the same sequence for every patient: intake, labs, a written protocol you approve, then ongoing adjustment against real data." data-id="element-372" data-mp="1ojgint3046pl" />

      <section className="bg-cream" data-id="element-373" data-mp="vt86qiz26ijg">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-12 md:px-8 md:pb-28" data-id="element-374" data-mp="10tvw707n2rbk">
          <ol data-id="element-375" data-mp="1rrn6nl7ym7si">
            {steps.map((step, index) => <li key={step.label} className="rule grid gap-6 py-10 lg:grid-cols-[6rem_1fr_1fr] lg:gap-12" data-id="element-376" data-mp="1rqvdeh1u4m5e" data-mpi={index}>
                <div data-id="element-377" data-mp="1ns63iyg09mqi">
                  <span className="font-serif text-4xl text-brick" data-id="element-378" data-mp="1izcx864w26cb">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <p className="mt-2 text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-379" data-mp="1dzgv6cfr4oze">
                    {step.duration}
                  </p>
                </div>
                <h2 className="font-serif text-3xl leading-tight text-ink md:text-[2.5rem]" data-id="element-380" data-mp="141sy3fuob5e2">
                  {step.title}
                </h2>
                <p className="max-w-xl text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-381" data-mp="100qwisdaah8x">
                  {step.detail}
                </p>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="border-y border-ink/10 bg-cream-deep text-ink" data-id="element-382" data-mp="2uc5nfci16mq9">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-383" data-mp="2pg6s14yac4gc">
          <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-384" data-mp="38iz4qi385fl1">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/2e100bad-ad12-4fe5-bf93-f579c92d013a.jpg" alt="A Republic clinician reviewing a patient panel" className="aspect-[3/2] w-full object-cover" data-id="element-385" data-mp="3dba3hhm8avc0" />
            <div data-id="element-386" data-mp="3s817k46ukv7y">
              <SectionHeading eyebrow="Your care team" tone="cream" title="One clinician, not a queue." intro="You are assigned a clinician licensed in your state who stays with you across renewals. Messages are answered within one business day, and dose changes do not require a new visit fee." data-id="element-387" data-mp="3s7hrkt0rcgwk" />
              <dl className="rule-light mt-10 grid gap-8 pt-8 sm:grid-cols-3" data-id="element-388" data-mp="26uoe5pmml095">
                {[{
                value: '< 24 hrs',
                label: 'Median protocol turnaround'
              }, {
                value: '2,100',
                label: 'Partner draw sites'
              }, {
                value: '50',
                label: 'States licensed'
              }].map(stat => <div key={stat.label} data-id="element-389" data-mp="1za41ryshzxu1">
                    <dt className="font-serif text-3xl text-brick" data-id="element-390" data-mp="1zd9ppape4to6">{stat.value}</dt>
                    <dd className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-391" data-mp="2da5dyae7qrot">{stat.label}</dd>
                  </div>)}
              </dl>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-cream-light" data-id="element-392" data-mp="1kk6fxpi1jk80">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-393" data-mp="1glgynltvtij3">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-394" data-mp="1ubsqrkqgvha8">
            <SectionHeading eyebrow="Questions" title="Answered plainly." data-id="element-395" data-mp="1ue5eyfmtinvq" />
            <FaqList items={faqs} data-id="element-396" data-mp="1pjsz0fkjvuoq" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-397" data-mp="11uq78ew7clgi" />
    </main>;
}